import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPStepConfigDto, PerFormaAPIService} from "src/app/services/pfapi.service";
import {PTPStepTypeOptions} from "../ptp-step-types";

@Component({
    selector: "app-ptp-step-edit",
    templateUrl: "./ptp-step-edit.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPStepEditComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private route: ActivatedRoute,
        private router: Router,
        private message: NzMessageService,
        private fb: FormBuilder
    ) {}

    loading = true;
    isEditMode = false;
    stepId?: number;
    stepTypeOptions = PTPStepTypeOptions;

    form: FormGroup = this.fb.group({
        stepName: ["", [Validators.required, Validators.maxLength(200)]],
        stepType: [0, [Validators.required]],
        order: [0, [Validators.required, Validators.min(0)]],
        showCreate: [false],
        dollarAmount: [null as number | null]
    });

    async ngOnInit() {
        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }

        this.isEditMode = true;
        this.stepId = Number(id);

        try {
            const step = await lastValueFrom(this.api.getApiConfigurePtpStepsId(this.stepId));
            this.form.patchValue({
                stepName: step.StepName,
                stepType: step.StepType,
                order: step.Order,
                showCreate: step.ShowCreate,
                dollarAmount: step.DollarAmount
            });
        } catch (e) {
            this.message.error("Failed to load step");
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    save = async () => {
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }

        this.loading = true;

        const dto: PTPStepConfigDto = {
            StepID: this.stepId,
            StepName: this.form.value.stepName,
            StepType: this.form.value.stepType,
            Order: this.form.value.order,
            ShowCreate: this.form.value.showCreate,
            DollarAmount: this.form.value.dollarAmount
        };

        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiConfigurePtpSteps(dto));
                this.message.success("Step updated");
            } else {
                await lastValueFrom(this.api.postApiConfigurePtpSteps(dto));
                this.message.success("Step created");
            }
            this.router.navigateByUrl("/configure/ptpstep");
        } catch (e) {
            this.message.error("Failed to save step");
            console.log(e);
            this.loading = false;
        }
    };
}
